import { Event } from '../../../types';
var trackEvent = function (eventLabel, nonInteractive) {
    // @ts-ignore
    if (typeof utag === 'undefined') {
        return;
    }
    var eventData = {
        event_name: 'eventTracker',
        event_cat: 'Modules',
        event_act: 'Chatbot',
        event_lab: eventLabel
    };
    if (nonInteractive) {
        eventData.ga_eventNonInteraction = 1;
    }
    /* eslint-disable */
    // @ts-ignore
    utag.link(eventData);
    /* eslint-enable */
};
var QuickReplyFlowCategories = {
    flight: 'Flight',
    hotel: 'Hotel',
    apartment: 'Apartment',
    villa: 'Villa',
    'dubai-5-star-hotels': '5 Star Hotels',
    'dubai-4-star-hotels': '4 Star Hotels',
    'dubai-apartments': 'Apartment',
    'dubai-resorts': 'Resort',
    'dubai-tours': 'Tour',
    'dubai-flights': 'Flight'
};
var CardSearchCategories = {
    'feature-flights': 'Flight',
    'feature-hotels': 'Hotel',
    'feature-apartments': 'Apartment',
    'dubai-5-star-hotels': '5 Star Hotel',
    'dubai-4-star-hotels': '4 Star Hotel',
    'dubai-resorts': 'Resort',
    'dubai-flights': 'Flight',
    'dubai-apartments': 'Apartment'
};
var DubaiCarouselCards = [
    'dubai-event-calendar',
    'dubai-things-to-do',
    'dubai-covid-info',
    'dubai-visa',
    'dubai-flights',
    'dubai-accommodation',
    'dubai-work-remotely',
    'super-sports-run',
    'la-perle-by-dragone',
    'dubai-events-calendar',
    'dubai-local-culture',
    'dubai-for-couples',
    'dubai-family-fun',
    'dubai-shopping-therapy',
    'dubai-beach-pool',
    'dubai-taste',
    'dubai-new-and-trending',
    'dubai-rock-ballet',
    'dubai-half-marathon',
    'dubai-rob-beckett',
    'dubai-expo2020',
    'dubai-study',
    'dubai-pass',
    'dubai-shopping-festival',
    'dubai-martin-garrix',
    'dubai-clubs',
    'dubai-van-gogh',
    'dubai-afrojack-steve-aoki',
    'dubai-food-festival'
];
window.__ET_INTERACTED_WITH_TEXT_AREA = false;
// eslint-disable-next-line complexity
var sendChatEventsToGA = function (event) {
    var chatEvent = event.detail;
    switch (chatEvent.type) {
        case Event.CLICKED_ON_PREVIEW: {
            trackEvent('Start Planning');
            break;
        }
        case Event.SEND_BUTTON_CLICKED: {
            if (!window.__ET_INTERACTED_WITH_TEXT_AREA) {
                window.__ET_INTERACTED_WITH_TEXT_AREA = true;
                trackEvent('Interacted with text area');
            }
            break;
        }
        case Event.CLICKED_QUICK_REPLY: {
            var QRClickedEvent = chatEvent;
            if (QRClickedEvent.tracking_id &&
                QuickReplyFlowCategories[QRClickedEvent.tracking_id]) {
                trackEvent("Category Selected : " + QuickReplyFlowCategories[QRClickedEvent.tracking_id]);
            }
            break;
        }
        case Event.CLICKED_CARD: {
            var cardClickedEvent = chatEvent;
            if (cardClickedEvent.tracking_id) {
                if (CardSearchCategories[cardClickedEvent.tracking_id]) {
                    trackEvent("Search Category Selected : " + CardSearchCategories[cardClickedEvent.tracking_id]);
                }
                else if (DubaiCarouselCards.includes(cardClickedEvent.tracking_id)) {
                    if (cardClickedEvent.tracking_label) {
                        trackEvent("" + cardClickedEvent.tracking_label);
                    }
                    else {
                        trackEvent(cardClickedEvent.card_title + " : " + cardClickedEvent.button_title);
                    }
                }
            }
            break;
        }
        case Event.LIKED_OFFER: {
            var offerLikedEvent = chatEvent;
            switch (offerLikedEvent.like_type) {
                case 'accommodation':
                    trackEvent('Add to favorite : Hotels');
                    break;
                case 'flight':
                    trackEvent('Add to favorite : Flights');
                    break;
            }
            break;
        }
        case Event.RECEIVED_FLIGHT_RESULTS:
        case Event.RECEIVED_FLIGHT_OFFERS: {
            var flightResultsEvent = chatEvent;
            trackEvent("Searching : Flights : Source City:" + flightResultsEvent.departure_location + " to Destination City:" + flightResultsEvent.destination_location + ": Arrival Date:" + flightResultsEvent.departure_date.substring(0, 10) + " - Departure Date:" + flightResultsEvent.return_date.substring(0, 10) + " : " + flightResultsEvent.adult_passengers + " Passenger");
            break;
        }
        case Event.RECEIVED_ACCOMMODATION_RESULTS:
        case Event.RECEIVED_ACCOMMODATION_OFFERS: {
            var accommodationResultsEvent = chatEvent;
            trackEvent("Searching : Hotels :Destination City:" + accommodationResultsEvent.location + " : Check-In Date:" + accommodationResultsEvent.check_in_date + " - Check-Out Date:" + accommodationResultsEvent.check_out_date);
            break;
        }
        case Event.CLICKED_ON_ACCOMMODATION_OFFER: {
            var clickedOnAccommodationOfferEvent = chatEvent;
            trackEvent("Hotel : View Details : " + clickedOnAccommodationOfferEvent.name);
            break;
        }
        case Event.RECEIVED_ACTIVITY_OFFERS: {
            var activityResultsEvent = chatEvent;
            trackEvent("Searching : Tours :Destination City:" + activityResultsEvent.location);
            break;
        }
        case Event.CLICKED_ON_ACTIVITY_OFFER:
        case Event.WIDGET_CLOSED: {
            trackEvent('Close popup');
            break;
        }
        case Event.WIDGET_OPENED: {
            trackEvent('Open popup');
            break;
        }
        case Event.COULD_NOT_UNDERSTAND: {
            var couldNotUnderstandEvent = chatEvent;
            trackEvent("404 Searches : " + couldNotUnderstandEvent.reference_message);
            break;
        }
        case Event.WIDGET_DISPLAYED: {
            trackEvent('Chatbot loaded', true);
            break;
        }
        case Event.CLICKED_ON_MESSAGE_LINK: {
            var clickedOnMessageLinkEvent = chatEvent;
            trackEvent("Clicked On Message Link : " + clickedOnMessageLinkEvent.url);
            break;
        }
    }
};
(function () {
    var w = document.querySelector('#__EDDY_TRAVELS_CHAT_WIDGET');
    var initEventListener = function (widget) {
        // @ts-ignore
        widget.addEventListener('__EDDY_TRAVELS_CHAT_EVENT', sendChatEventsToGA);
    };
    if (w) {
        initEventListener(w);
        return;
    }
    new MutationObserver(function (mutationRecords, observer) {
        Array.from(document.querySelectorAll('#__EDDY_TRAVELS_CHAT_WIDGET')).forEach(function (widget) {
            if (widget) {
                initEventListener(widget);
                observer.disconnect();
            }
        });
    }).observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();
